<template>
	<div class="common-tab common-tab--normal">
		<div
			v-for="(item, index) in option"
			:key="index"
			class="common-tab-item"
			:class="{ 'common-tab-item--active': item.value == innerValue }"
			@click="changeTab(item, index)"
		>
			{{ item.label }}
		</div>
	</div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
	value: {
		type: [String, Number],
		default: ''
	},
	option: {
		type: Array,
		default: () => [] // { label, value }
	}
});
const emits = defineEmits(['change', 'update:value']);
const innerValue = computed({
	get: () => props.value,
	set: val => {
		emits('update:value', val);
	}
});
const changeTab = (item, idx) => {
	if (innerValue.value == item.value) return;
	innerValue.value = item.value;
	emits('change', {
		index: idx,
		value: item.value,
		data: props.option[idx]
	});
};
</script>

<style lang="less" scoped>
.common-tab {
	display: inline-flex;

	&-item {
		font-family: Barlow;
		font-style: normal;
		background: transparent;
		cursor: pointer;

		&--active {
			font-weight: 500;
		}
	}

	&--normal {
		.common-tab-item {
			font-size: 1.8rem;
			color: #86909c;
			position: relative;
			font-family: 'SourceHanSansCN-Medium';
			& + .common-tab-item {
				margin-left: 60px;
			}
			&--active {
				color: #1d2129;

				&::after {
					content: '';
					margin: 0 auto;
					margin-top: 10px;
					display: block;
					width: 3.4rem;
					height: 4px;
					background: var(--theme-color);
				}
			}
		}
	}
}
</style>
<style lang="less">
.Mobile {
	.common-tab {
		display: flex;
		overflow-x: auto;
		overflow-y: hidden;

		position: relative;
		left: -2.1rem;
		right: -2.1rem;
		width: 100vw;
		padding: 0 2.1rem;

		// 解决ios滑动不流畅
		-webkit-overflow-scrolling: touch;
		&::-webkit-scrollbar {
			display: none;
		}

		&-item {
			flex-shrink: 0;
		}
	}
}
</style>
